import { readLocalStorage } from 'redux/saga/helpers/local-storage';
import { CORPORATE_PARTNER_STORAGE_KEY, CORPORATE_PARTNER_JUSTWORKS } from 'constants/corporate';
import PlanDeriver from 'derivers/Plan';

export function getCorporateDetails(planCode) {
  const corporatePartnerObj = readLocalStorage(CORPORATE_PARTNER_STORAGE_KEY) || {};
  return PlanDeriver.isCorporateJustworks(planCode) &&
    corporatePartnerObj.partner &&
    corporatePartnerObj.partner === CORPORATE_PARTNER_JUSTWORKS
    ? corporatePartnerObj
    : undefined;
}

export function parseCorporatePartnerPath(path) {
  return path && path.split('-')[0];
}
